import React, { useState } from "react";
import ExpandableCard from "./ExpandableCard";
import CardBackdrop from "./CardBackdrop";

interface ExpandableCardGridProps {
  cards: Array<React.ComponentProps<typeof ExpandableCard>>;
  className?: string;
  style?: React.CSSProperties;
  columnClasses?: string;
}

const ExpandableCardGrid: React.FC<ExpandableCardGridProps> = ({
  cards,
  className = "",
  style = {},
  columnClasses = "col-lg-3 col-md-4 col-sm-6 col-6",
}) => {
  const [expandedCardId, setExpandedCardId] = useState<number | string | null>(null);

  const handleCardExpand = (id: number | string) => {
    setExpandedCardId(expandedCardId === id ? null : id);
  };

  return (
    <div className={`position-relative ${className}`} style={style}>
      <CardBackdrop 
        isVisible={expandedCardId !== null} 
        onClick={() => setExpandedCardId(null)} 
      />
      
      <div className="row">
        {cards.map((card, index) => (
          <div 
            key={index} 
            className={`${columnClasses} p-0 position-relative ${card.isPackage ? 'col-12 col-lg-4 col-md-6' : ''}`}
          >
            <ExpandableCard 
              {...card} 
              isExpanded={expandedCardId===card.id}
              onExpand={handleCardExpand}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default ExpandableCardGrid;